import { computed, Injectable, signal } from '@angular/core';

/**
 * Tracks how many Feedback API requests are currently in flight, exposing a
 * `loading` signal that is true whenever at least one is pending.
 *
 * Driven by {@link feedbackApiLoadingInterceptor}; read by the UI (e.g. a
 * loading bar). Counts requests rather than using a boolean so overlapping
 * requests don't hide the indicator prematurely.
 */
@Injectable({ providedIn: 'root' })
export class FeedbackApiLoadingService {
  private readonly activeCount = signal(0);

  /** True while one or more Feedback API requests are pending. */
  readonly loading = computed(() => this.activeCount() > 0);

  /** Mark a request as started. */
  start(): void {
    this.activeCount.update((count) => count + 1);
  }

  /** Mark a request as finished (completed, errored, or cancelled). */
  stop(): void {
    this.activeCount.update((count) => Math.max(0, count - 1));
  }
}
